/*
 *
 * PaymentMethodsV2 constants
 *
 */

const BASE_ACTION_CONSTANT = 'app/PaymentMethodsV2';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const GET_DOCS_PER_PAYMENT_METHOD = `${BASE_ACTION_CONSTANT}/GET_DOCS_PER_PAYMENT_METHOD`;

export const SAVE_UPLOAD_DOCUMENTS_FORM = `${BASE_ACTION_CONSTANT}/SAVE_UPLOAD_DOCUMENTS_FORM`;

export const DOWNLOAD_DOCUMENT = `${BASE_ACTION_CONSTANT}/DOWNLOAD_DOCUMENT`;

export const ENABLE_PAYMENT_METHOD = `${BASE_ACTION_CONSTANT}/ENABLE_PAYMENT_METHOD`;

export const HANDLE_ENABLE_PAYMENT_METHODS_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_ENABLE_PAYMENT_METHODS_RESPONSE`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_PAYMENT_METHODS = `${BASE_ACTION_CONSTANT}/GET_PAYMENT_METHODS`;

export const HANDLE_PAYMENT_METHODS_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_PAYMENT_METHODS_RESPONSE`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const GET_PAYTM_DATA = `${BASE_ACTION_CONSTANT}/GET_PAYTM_DATA`;

export const SAVE_PAYTM_DATA = `${BASE_ACTION_CONSTANT}/SAVE_PAYTM_DATA`;

export const GET_PAYTM_TEST_CONFIG = `${BASE_ACTION_CONSTANT}/GET_PAYTM_TEST_CONFIG`;

export const SAVE_PAYTM_PROD_CONFIG = `${BASE_ACTION_CONSTANT}/SAVE_PAYTM_PROD_CONFIG`;

export const SAVE_PAYTM_TEST_CONFIG = `${BASE_ACTION_CONSTANT}/SAVE_PAYTM_TEST_CONFIG`;

export const ADD_PAYTM_PROD_CONFIG = `${BASE_ACTION_CONSTANT}/ADD_PAYTM_PROD_CONFIG`;

export const ADD_PAYTM_TEST_CONFIG = `${BASE_ACTION_CONSTANT}/ADD_PAYTM_TEST_CONFIG`;

export const GET_PAYTM_CHECKSUMHASH = `${BASE_ACTION_CONSTANT}/GET_PAYTM_CHECKSUMHASH`;

export const RESET_PAYTM_WALLET = `${BASE_ACTION_CONSTANT}/RESET_PAYTM_WALLET`;

export const GET_PAYPAL_CONFIG = `${BASE_ACTION_CONSTANT}/GET_PAYPAL_CONFIG`;

export const HANDLE_PAYPAL_CONFIG_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_PAYPAL_CONFIG_RESPONSE`;

export const INITIATE_PAYPAL = `${BASE_ACTION_CONSTANT}/INITIATE_PAYPAL`;

export const SAVE_PAYPAL_DATA = `${BASE_ACTION_CONSTANT}/SAVE_PAYPAL_DATA`;

export const RESET_PAYPAL_CONFIG = `${BASE_ACTION_CONSTANT}/RESET_PAYPAL_CONFIG`;

export const ACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/ACTIVATE_PAYPAL_CURRENCY`;

export const DEACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/DEACTIVATE_PAYPAL_CURRENCY`;

export const UPDATE_DEFAULT_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/UPDATE_DEFAULT_PAYPAL_CURRENCY`;

export const HANDLE_UPDATE_DEFAULT_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/HANDLE_UPDATE_DEFAULT_PAYPAL_CURRENCY`;

export const HANDLE_DEACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/HANDLE_DEACTIVATE_PAYPAL_CURRENCY`;

export const HANDLE_ACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/HANDLE_ACTIVATE_PAYPAL_CURRENCY`;

export const ACCESS_COD_HANDELING_CHARGES = `${BASE_ACTION_CONSTANT}/ACCESS_COD_HANDELING_CHARGES`;

export const ACCESS_PIN_CODE_AMOUNT = `${BASE_ACTION_CONSTANT}/ACCESS_PIN_CODE_AMOUNT`;
export const UPDATE_PAYPAL_CONFIG = `${BASE_ACTION_CONSTANT}/UPDATE_PAYPAL_CONFIG`;

export const INTERNATIONAL_WALLET = 'International Wallet';

export const INTERNATIONAL_CARDS = 'International Cards';

export const CASH_ON_DELIVERY = 'CASH';

export const CASH = 'cash';

export const WALLET = 'Wallet';

export const NET_BANKING = 'NET_BANKING';

export const PAY_LATER = 'Pay Later';

export const MENU_ITEMS = [
  {
    key: 'UPI',
    name: 'UPI',
  },
  {
    key: NET_BANKING,
    name: 'Net Banking',
  },
  {
    key: 'CARDS',
    name: 'Cards',
  },
  {
    key: WALLET,
    name: 'Wallets',
  },
  {
    key: 'CARDLESS_EMI',
    name: 'Cardless EMI',
  },
  {
    key: 'DEBIT_CARD_EMI',
    name: 'Debit Card EMI',
  },
  {
    key: 'CREDIT_CARD_EMI',
    name: 'Credit Card EMI',
  },
  {
    key: 'PAY_LATER',
    name: PAY_LATER,
  },
  {
    key: INTERNATIONAL_WALLET,
    name: 'International Wallet',
  },
  {
    key: INTERNATIONAL_CARDS,
    name: 'International Cards',
  },
  {
    key: CASH_ON_DELIVERY,
    name: 'Cash On Delivery',
  },
];

export const UPI_PAYMENT_METHODS = [
  'GOOGLE_PAY',
  'BHIM_UPI',
  'AMAZONPAY',
  'PAYTM',
  'PHONEPE',
  'WHATSAPP_PAYMENT_MODE',
];

export const NOT_CONFIGURABLE_MESSAGE =
  'This payment method cannot be requested for enablement from merchant dashboard. Contact your account manager or write to us at care@cashfree.com to enable this.';

export const DISABLED_REASON_MAPPER = {
  'DUE TO COMMERCIALS': ' due to commercials',
  'REQUESTED BY MERCHANT': ' as per your request',
};

export const DISABLED_REASON =
  'This payment mode is disabled for your account$reason$. Contact your account manager or write to us at care@cashfree.com for further details.';

export const DIGITAL_GOODS_GAMES = 5816;

export const REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS = 6513;

export const WALLET_TOP_UP = 6540;

export const NEGATIVE_MCC_CODES_FOR_UPI = [
  DIGITAL_GOODS_GAMES,
  REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS,
  WALLET_TOP_UP,
];

export const REJECTED = 'REJECTED';

export const DISABLED = 'DISABLED';

export const IN_REVIEW = 'IN_REVIEW';

export const ACTIVATED = 'ACTIVATED';

export const AVAILABLE = 'AVAILABLE';

export const NOT_AVAILABLE = 'NOT_AVAILABLE';

export const ACTIVATION_FAILED = 'ACTIVATION_FAILED';

export const ORG_TYPES_BLOCKED_FOR_INTERNATIONAL_CARDS = ['INDIVIDUAL'];

export const STATUS_COLOR_MAPPER = {
  IN_REVIEW: 'warning',
  REJECTED: 'danger',
  DISABLED: 'body',
  ACTIVATED: 'success',
};

export const STATUS_MAPPER = {
  IN_REVIEW: 'Pending',
  REJECTED: 'Rejected',
  DISABLED: 'Disabled',
  ACTIVATED: 'Active',
};

export const PAYTM_CONFIG = {
  merchantPaytmKey: 'Merchant Key',
  merchantPaytmId: 'Paytm ID',
  merchantPaytmWebsiteUrl: 'Website URL',
  merchantPaytmIndustryType: 'Industry Type ID',
  merchantPaytmChannelId: 'Paytm Channel ID',
};

export const PAYPAL_CONFIG = [
  {
    key: 'mid',
    displayText: 'Paypal MID',
    isEditable: false,
    showInfoIcon: false,
  },
  // {
  //   key: 'conFee',
  //   displayText: 'Convenience Fee',
  //   isAmount: true,
  //   isEditable: false,
  //   showInfoIcon: false,
  // },
  // {
  //   key: 'flatFee',
  //   displayText: 'Convenience Fee (Flat)',
  //   isAmount: true,
  //   isEditable: false,
  //   showInfoIcon: false,
  // },
  {
    key: 'defaultPaypalCurrency',
    displayText: 'Default Currency',
    isEditable: true,
    showInfoIcon: false,
  },
  {
    key: 'activePaypalCurrencies',
    displayText: 'Active Currencies',
    isEditable: true,
    showInfoIcon: false,
  },
];

export const PAYPAL = 'PAYPAL';

export const PAYTM = 'PAYTM';

export const START = 'START';

export const FIRST = 'FIRST';

export const SECOND = 'SECOND';

export const COMPLETED = 'COMPLETED';

export const PAYTM_MODAL = 'PAYTM_MODAL';

export const CONFIRM_PAYTM_MODAL = 'CONFIRM_PAYTM_MODAL';

export const PAYTM_REPORT_GENERATED = 'PAYTM_REPORT_GENERATED';

export const CONNECT_PAYTM_ACCOUNT_SUCCESS = 'CONNECT_PAYTM_ACCOUNT_SUCCESS';

export const RESET_PAYPAL_MODAL = 'RESET_PAYPAL_MODAL';

export const RESET_PAYTM_MODAL = 'RESET_PAYTM_MODAL';

export const GMAIL_LINK = 'https://mail.google.com/';

export const ERROR_CONFIG = 'ERROR_CONFIG';

export const PAYTM_CODE = 4007;

export const PAYPAL_CODE = 5001;

export const LAZYPAY_CODE = 4503;

export const CASH_ON_DELIVERY_CODE = 12002;

export const PAYTM_DASHBOARD_LINK = 'https://dashboard.paytm.com/next/apikeys';

export const PAYTM_DOC_LINK =
  'https://docs.cashfree.com/docs/activate-payment-methods#activate-payment-mode---paytm';

export const STANDARD_PRICING_LINK =
  'https://www.cashfree.com/payment-gateway-charges';

export const PAYPAL_DOCS_LINK =
  'https://docs.cashfree.com/docs/activate-payment-methods#activate-payment-mode---paypal';

export const DOCUMENT_STATUS_APPROVED = 'APPROVED';

export const SIZE_LIMIT = 2097152;

export const GET_PAYMENT_METHODS_URL = {
  url: '/pg/payment-methods/mapping',
  method: 'GET',
};

export const GET_DOCS_PER_PAYMENT_METHOD_URL = {
  url: '/pg/payment-methods/documents',
  method: 'PATCH',
};

export const ENABLE_PAYMENT_METHOD_URL = {
  url: '/pg/payment-methods/enable',
  method: 'POST',
};

export const GET_PAYMENT_METHOD_BY_STATUS_URL = {
  url: '/pg/paymentmode/status',
  method: 'GET',
};

export const GET_PAYTM_PROD_CONFIG_URL = {
  url: '/pg/paytm/config/prod',
  method: 'GET',
};

export const ADD_PAYTM_PROD_CONFIG_URL = {
  url: '/pg/paytm/config/prod',
  method: 'PATCH',
};

export const GET_PAYTM_TEST_CONFIG_URL = {
  url: '/pg/paytm/config',
  method: 'GET',
};

export const ADD_PAYTM_TEST_CONFIG_URL = {
  url: '/pg/paytm/config',
  method: 'POST',
};

export const UPDATE_PAYTM_TEST_CONFIG_URL = {
  url: '/pg/paytm/config',
  method: 'PATCH',
};

export const GET_PAYTM_CHECKSUMHASH_URL = {
  url: '/pg/paytm/config/checksum',
  method: 'POST',
};

export const RESET_PAYTM_WALLET_URL = {
  url: '/pg/paytm/config/deactivate',
  method: 'PATCH',
};

export const INITIATE_PAYPAL_URL = {
  url: '/pg/paypal/initiate',
  method: 'POST',
};

export const GET_PAYPAL_CONFIG_URL = {
  url: '/pg/paypal/configs',
  method: 'GET',
};

export const GET_PAYPAL_CURRENCIES_URL = {
  url: '/pg/paypal/currencies',
  method: 'GET',
};

export const GET_ACTIVE_PAYPAL_CURRENCIES_URL = {
  url: '/pg/paypal/currencies/active',
  method: 'GET',
};

export const SAVE_PAYPAL_DATA_URL = {
  url: '/pg/paypal/onboardreturn',
  method: 'POST',
};

export const GET_DEFAULT_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/default',
  method: 'GET',
};

export const UPDATE_DEFAULT_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/$currency_code$/make-default',
  method: 'PATCH',
};

export const DEACTIVATE_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/$currency_code$/deactivate',
  method: 'PATCH',
};

export const ACTIVATE_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/$currency_code$/activate',
  method: 'PATCH',
};

export const RESET_PAYPAL_CONFIG_URL = {
  url: '/pg/paypal/reset',
  method: 'PATCH',
};

export const ACCESS_COD_HANDELING_CHARGE = {
  url: '/pg/payment-mode-rates/config',
};

export const ACCESS_AMOUNT_AND_PIN_CODES_URL = {
  url: '/pg/eligibility/rules',
};
export const UPDATE_PAYPAL_CONFIG_URL = {
  url: '/pg/paypal/configs',
  method: 'PATCH',
};

export const PDF = 'PDF';

export const XLS = 'XLS';

export const DROPDOWN = 'DROPDOWN';

export const TEXT = 'TEXT';

export const TEXTAREA = 'TEXTAREA';

export const INSTANT_TAT = 'INSTANT';

export const checkList = [
  'Max file size: 500kb',
  'pinCode  is mandatory',
  'Upload only .csv',
];

export const COD_CSV_HEADERS = ['pinCode'];

export const COD_CSV_FILTERS = {
  headers: COD_CSV_HEADERS,
  errorMessage: 'Please enter valid header name in CSV',
};

export const SAMPLE_FILE_URL =
  'https://cashfreelogo.cashfree.com/ass/COD-PINCODES+-+Sheet1.csv';
